var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var BarCharts = /** @class */ (function () {
    function BarCharts() {
        this.chartList = new Array();
        this.hasShadows = false;
    }
    BarCharts.prototype.add = function (chart) {
        this.chartList.push(chart);
    };
    BarCharts.prototype.count = function () {
        return this.chartList.length;
    };
    BarCharts.prototype.titleOfChart = function (index) {
        return this.chartList[index].title;
    };
    BarCharts.prototype.unitsOfChart = function (index) {
        return this.chartList[index].unitsTitle;
    };
    BarCharts.prototype.numBarsInChart = function (index) {
        return this.chartList[index].numBars();
    };
    BarCharts.prototype.nodeNameOfChart = function (index) {
        return this.chartList[index].nodeName;
    };
    BarCharts.prototype.shadowNodeNameOfChart = function (index) {
        return this.chartList[index].shadowNodeName;
    };
    BarCharts.prototype.barsInChart = function (index) {
        return this.chartList[index].bars;
    };
    BarCharts.prototype.makeShadowsFrom = function (shadowCharts) {
        this.hasShadows = true;
        // ASSUMPTION: charts are lined up properly
        for (var i = 0; i < this.chartList.length; i++) {
            this.chartList[i].makeShadowsFrom(shadowCharts.chartList[i]);
        }
    };
    BarCharts.prototype.produceSetup = function () {
        var answer = new Array();
        for (var i = 0; i < this.chartList.length; i++) {
            var eachSetup = {};
            eachSetup["title"] = this.chartList[i].title;
            eachSetup["units"] = this.chartList[i].unitsTitle;
            eachSetup["shouldTotal"] = false;
            eachSetup["useMaxMin"] = false;
            eachSetup["nodeName"] = this.nodeNameOfChart(i);
            eachSetup["shadowNodeName"] = this.shadowNodeNameOfChart(i);
            answer.push(eachSetup);
        }
        return answer;
    };
    BarCharts.prototype.produceInputData = function () {
        var answer = new Array();
        for (var i = 0; i < this.chartList.length; i++) {
            var eachInputData = new Array();
            var chart = this.chartList[i];
            for (var j = 0; j < chart.numBars(); j++) {
                var eachInputObject = {};
                eachInputObject["label"] = chart.titleOfBar(j).toString();
                eachInputObject["value"] = chart.valueOfBar(j);
                eachInputObject["color"] = 7960064;
                eachInputData.push(eachInputObject);
            }
            answer.push(eachInputData);
        }
        return answer;
    };
    BarCharts.prototype.produceShadowData = function () {
        if (this.hasShadows === false) {
            return undefined;
        }
        var answer = new Array();
        for (var i = 0; i < this.chartList.length; i++) {
            var eachInputData = new Array();
            var chart = this.chartList[i];
            for (var j = 0; j < chart.numBars(); j++) {
                var eachInputObject = {};
                eachInputObject["label"] = chart.titleOfBar(j).toString();
                eachInputObject["value"] = chart.shadowValueOfBar(j);
                eachInputObject["color"] = 7960064;
                eachInputData.push(eachInputObject);
            }
            answer.push(eachInputData);
        }
        return answer;
    };
    return BarCharts;
}());
var HorizLineChart = /** @class */ (function (_super) {
    __extends(HorizLineChart, _super);
    function HorizLineChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HorizLineChart.prototype.produceInputData = function () {
        return this.produceGoogleInputData();
    };
    HorizLineChart.prototype.produceGoogleInputData = function () {
        var answer = new Array();
        var titleList = new Array();
        titleList.push("Year");
        for (var i = 0; i < this.chartList.length; i++) {
            var chart = this.chartList[i];
            titleList.push(chart.title);
        }
        answer.push(titleList);
        for (var i = 0; i < this.chartList[0].toLineChartArray().length; i++) {
            var row = new Array();
            row.push(this.chartList[0].toLineChartArray()[i].x);
            for (var j = 0; j < this.chartList.length; j++) {
                row.push(this.chartList[j].toLineChartArray()[i].y);
            }
            answer.push(row);
        }
        return answer;
    };
    HorizLineChart.prototype.produceNvd3InputData = function () {
        var answer = new Array();
        for (var i = 0; i < this.chartList.length; i++) {
            var chart = this.chartList[i];
            var linePoints = chart.toLineChartArray();
            var eachObject = { values: linePoints, key: chart.title };
            answer.push(eachObject);
        }
        return answer;
    };
    return HorizLineChart;
}(BarCharts));
var BarChart = /** @class */ (function () {
    function BarChart(chartTitle, unitsTitle, nodeName, shadowNodeName) {
        this.title = chartTitle;
        this.unitsTitle = unitsTitle;
        this.nodeName = nodeName;
        this.shadowNodeName = shadowNodeName;
        this.bars = new Array();
        this.barHash = {};
    }
    BarChart.prototype.numBars = function () {
        return this.bars.length;
    };
    BarChart.prototype.addBar = function (title, value) {
        var bar = new Bar(title);
        bar.setValue(value);
        this.bars.push(bar);
        this.barHash[title] = bar;
    };
    BarChart.prototype.addShadowBar = function (title, value) {
        var bar = this.barHash[title];
        if (bar === undefined) {
            bar = new Bar(title);
            bar.setShadowValue(value);
            this.bars.push(bar);
            this.barHash[title] = bar;
        }
        else {
            bar.setShadowValue(value);
        }
    };
    BarChart.prototype.titleOfBar = function (index) {
        var bar = this.bars[index];
        return bar.title;
    };
    BarChart.prototype.valueOfBar = function (index) {
        return this.bars[index].value;
    };
    BarChart.prototype.shadowValueOfBar = function (index) {
        return this.bars[index].shadowValue;
    };
    BarChart.prototype.makeShadowsFrom = function (chart) {
        this.shadowNodeName = chart.nodeName;
        for (var i = 0; i < chart.numBars(); i++) {
            var bar = chart.bars[i];
            this.addShadowBar(bar.title, bar.value);
        }
    };
    BarChart.prototype.toValueArray = function () {
        var result = new Array();
        for (var i = 0; i < this.bars.length; i++) {
            var value = this.valueOfBar(i);
            result.push(value);
        }
        return result;
    };
    BarChart.prototype.toLineChartArray = function () {
        var answer = new Array();
        for (var i = 0; i < this.bars.length; i++) {
            var obj = { x: this.titleOfBar(i), y: parseInt(this.valueOfBar(i)) };
            answer.push(obj);
        }
        return answer;
    };
    return BarChart;
}());
var Bar = /** @class */ (function () {
    function Bar(title) {
        this.title = title;
    }
    Bar.prototype.setValue = function (value) {
        this.value = value;
    };
    Bar.prototype.setShadowValue = function (value) {
        this.shadowValue = value;
    };
    return Bar;
}());
//# sourceMappingURL=chart.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/add-tables/app/js/logic/chart.js